import React from 'react'
import './index.scss'

const ResponsiveNavLayout = ({
  isRoot,
  className,
  header,
  sidebar,
  content,
}) => {
  const classNames = ['responsive-nav-layout']
  if (className) classNames.push(className)
  if (isRoot) classNames.push('root')

  return (
    <section className={classNames.join(' ').trim()}>
      <section className="heading">
        {header}
      </section>
      <aside className="sidebar">
        {sidebar}
      </aside>

      <section className="content">
        {content}
      </section>
    </section>
  )
}

export default ResponsiveNavLayout
